import {
  withStyles,
  Grid,
  Checkbox,
  FormControlLabel,
  Radio,
} from "@material-ui/core";
import React, { useEffect, useState } from "react";
import Colors from "../../../template/Colors";
import { InputForm } from "../../../components/Input/InputDadosCadastraisPaciente";
import { InputDateForm, InputTimeForm } from "../../../components/Modal/Input";
import { ReactSelect } from "../../../components/Select/SelectSearch";
import CustomDateTimePicker from "../../../components/CustomDateTimePicker";
import moment from "moment";
import TextCharCounter from "../../../components/TextCharCounter/TextCharCounter";

const TiposCampoAnamnese = (props) => {
  const {
    classes,
    label,
    tipocampo,
    onChange,
    respostas,
    onChangeTipoComMultiplasRespostas,
    onChangeOutro,
    readOnly,
    textLength,
    possuiRespostaPadrao,
  } = props;

  const [valueCombobox, setValueCombobox] = useState(undefined);

  useEffect(() => {
    const findValue = (condition) => {
      return respostas.find(item => condition(item));
    };

    if (tipocampo === "COMBOBOX") {
      const condition = readOnly ? (item => item?.valorConvertido) : (item => booelean[item?.valorResposta]);
      const respostaTrue = findValue(condition);
      setValueCombobox(respostaTrue);
    }
  }, [respostas, tipocampo, readOnly]);

  const changeCombobox = (e, tipocampo) => {
    setValueCombobox(e);
    onChangeTipoComMultiplasRespostas(e, tipocampo);
  }

  const booelean = {
    true: true,
    false: false
  }

  const validaHorario = (readOnly, respostas) => {

    if (!respostas) return null

    const valorUtilizado = readOnly ? respostas[0]?.valorConvertido : respostas[0]?.valorResposta
    const formato = 'YYYY-MM-DDTHH:mm:ss'
    const horarioValido = valorUtilizado && moment(valorUtilizado, formato).isValid()
    const dataAtual = moment().format("YYYY-MM-DD")

    if (horarioValido) {
      return moment(valorUtilizado).format(formato)
    } else if (!horarioValido && valorUtilizado) {
      return `${dataAtual}T${valorUtilizado}`
    }
    return null
  }

  const convertBoolean=(value)=>{
    return value === "true" ||  value === true
  }


  const renderTipoCampo = () => {
    switch (tipocampo) {
      case "INPUT": 
        return (
          <>
            <input
              id="prt-tca-inp-txt"
              readOnly={readOnly}
              onChange={(e) => onChange(e, tipocampo)}
              className={classes.input}
              value={readOnly ? respostas[0]?.valorConvertido : (respostas[0]?.valorResposta || "")}
            />
            <TextCharCounter
              currQuantity={textLength}
              limit={4000}
            />
          </>
        );
      case "TEXT_AREA":
        return (
          <>
            <InputForm
              id="prt-tca-inp-txa"
              readOnly={readOnly}
              value={readOnly ? respostas[0]?.valorConvertido : (respostas[0]?.valorResposta || "")}
              className={classes.textArea}
              rowsMax={20}
              rows={4}
              multiline
              onChange={(e) => onChange(e, tipocampo)}
            />
            <TextCharCounter
              currQuantity={textLength}
              limit={4000}
            />
          </>
        );
      case "RADIO":
        const respostasMultiplaEscolha = respostas?.map((item, index) => {
          const nomeLabel = ( item.nome === "" && !possuiRespostaPadrao )? "Outro:" : item.nome;
          return (
            <div className={classes.opcaoOutroComInput} key={index}>
              <FormControlLabel
                control={
                  <>
                    <Radio
                      id={`prt-tca-inp-rad-${index}`}
                      key={readOnly ? item?.valorConvertido : item.valorResposta}
                      disabled={readOnly}
                      color="primary"
                      checked={readOnly ? item?.valorConvertido : convertBoolean(item.valorResposta)}
                      onChange={(e) => onChangeTipoComMultiplasRespostas(e, tipocampo, index)}
                    />
                  </>
                }
                label={nomeLabel}
              />
              {nomeLabel === "Outro:" && (
                <input
                  id={`prt-tca-inp-out-${index}`}
                  disabled={!item.valorResposta || readOnly}
                  value={item.outro || ""}
                  onChange={(e) => onChangeOutro(e, index)}
                  className={[`${classes.input}  ${classes.inputOutro}`]}
                />
              )}
            </div>
          );
        });

        return respostasMultiplaEscolha;
      case "CHECKBOX":
        const respostasCheckbox = respostas?.map((item, index) => {
          const nomeLabel = ( item.nome === "" && !possuiRespostaPadrao )? "Outro:" : item.nome;

          return (
            <div className={classes.opcaoOutroComInput} key={index}>
              <FormControlLabel
                control={
                  <Checkbox
                    id={`prt-tca-inp-chk-${index}`}
                    className={classes.checkboxColor}
                    disabled={readOnly}
                    checked={readOnly ? item?.valorConvertido : convertBoolean(item.valorResposta)}
                    color="primary"
                    onChange={(e) => onChangeTipoComMultiplasRespostas(e, tipocampo, index)}
                  />
                }
                label={nomeLabel}
                className={classes.labelRespostas}
              />
              {nomeLabel === "Outro:" && (
                <input
                  id={`prt-tca-inp-out-${index}`}
                  readOnly={!item.valorResposta || readOnly}
                  onChange={(e) => onChangeOutro(e, index)}
                  value={item.outro || ""}
                  className={[`${classes.input}  ${classes.inputOutro}`]}
                />
              )}
            </div>
          );
        });

        return respostasCheckbox;
      case "COMBOBOX":
        return (
          <>
            {readOnly ?
              <input
                id="prt-tca-inp-cmb"
                className={classes.input}
                value={valueCombobox?.nome || ""}
                readOnly
              />
              :
              <ReactSelect
                id="prt-tca-sel-cmb"
                placeholder={"Selecione"}
                onChange={(e) => changeCombobox(e, tipocampo)}
                options={respostas || []}
                value={valueCombobox}
                isClearable
                getOptionLabel={(option) => option.nome}
                getOptionValue={(option) => option.id}
              />
            }
          </>
        );
      case "DATE":
        return (
          <Grid item className={classes.paddingTipoDate}>
            <InputDateForm
              id="prt-tca-inp-dat"
              disabled={readOnly}
              iconposition="end"
              classes={{
                input: classes.inputColor,
                date: classes.date,
              }}
              value={readOnly ? respostas[0]?.valorConvertido : (respostas[0]?.valorResposta || null)} 
              onChange={(e) => onChange(e, tipocampo)}
            />
          </Grid>
        );

      case "TIME":
        return (
          <Grid item className={classes.paddingTipoDate}>
            <InputTimeForm
              id="prt-tca-inp-tim"
              disabled={readOnly}
              classes={{
                input: classes.inputColor,
                icon: classes.iconTime,
                date: classes.dateTime,
              }}
              iconposition="end"
              value = {validaHorario(readOnly,respostas)} 
              onChange={(e) => onChange(e, "TIME")}
            />
          </Grid>
        );

      case "DATETIME":
        return (
          <Grid item className={classes.paddingTipoDate}>
            <CustomDateTimePicker
              id="prt-tca-inp-dtm"
              disabled={readOnly}
              disabletoolbar={readOnly.toString()}
              onChange={(e) => onChange(e, "DATETIME")}
              value={readOnly ? (respostas[0]?.valorConvertido) : (respostas[0]?.valorResposta || null)}
              invalidLabel=""
              invalidDateMessage=""
            />
          </Grid>
        );
      case "NUMBER":
        return (
          <input
            id="prt-tca-inp-num"
            value={readOnly ? respostas[0]?.valorConvertido : respostas[0]?.valorResposta}
            readOnly={readOnly}
            onChange={(e) => onChange(e, "NUMBER")}
            className={classes.input}
            type="number"
            min={0}
          />
        );
      default:
        return;
    }
  };

  return (
    <div className={classes.divLabel}>
      <span className={classes.titulo}>{label}</span>
      {renderTipoCampo()}
    </div>
  );
};

const style = {
  divLabel: {
    display: "flex",
    flexDirection: "column",
    width: "100%",
    marginBottom: 20,
  },
  titulo: {
    color: Colors.commons.gray7,
    fontSize: "12px !important",
    fontWeight: 400,
    marginBottom: 4,
  },
  input: {
    borderRadius: 100,
    padding: "4px 15px",
    background: Colors.commons.gray11,
    color: Colors.commons.gray9,
    fontFamily: "Poppins",
    border: "none",
    height: "24px",
    "&::disabled": {
      color: Colors.commons.gray9,
    }
  },
  textArea: {
    background: "#F2F2F2",
    borderRadius: "10px",
    padding: "0px 8px",
    maxHeight: "101px",
    overflow: "auto",
    "& textarea": {
      color: Colors.commons.gray9,
    },
  },
  iconTime: {
    "& button": {
      background: Colors.commons.gray2,
      "&:disabled": {
        background: `${Colors.commons.gray2} !important`,
      }
    },
  },
  inputColor: {
    color: Colors.commons.gray9,
  },
  opcaoOutroComInput: {
    display: "flex",
    flexDirection: "row",
    "&>label": {
      "&>span": {
        padding: "0 5px 0 0",
      },
    },
  },
  inputOutro: {
    width: "100%",
  },
  dateTime: {
    marginTop: "0px !important",
    borderRadius: '100px',
  },
  paddingTipoDate: {
    padding: "0 5px"
  },
  labelRespostas: {
    "&>span:last-child": {
      color: `${Colors.commons.gray9} !important`,
    },
  },
  checkboxColor: {
    color: Colors.commons.gray7
  },
  date: {
    borderRadius: '100px',
  },
};

export default withStyles(style)(TiposCampoAnamnese);
